import { SECTION_BUDGET } from "common/routes/sections/main.sections";

export const START_BUDGET = {
  path: "start/",
  params: ":scenarioId?/",
  subtitle: "Create Budget Scenario",
  title: "",
  withStepper: true,
  withDate: false,
  step: 0,
};

export const SELECT_ACCOUNTS = {
  path: "accounts/",
  subtitle: "Create Budget Scenario",
  title: "",
  withStepper: true,
  withDate: false,
  step: 1,
};

export const CREATE_COMPANY = {
  path: "company-structure/",
  subtitle: "Create Budget Scenario",
  title: "",
  withStepper: true,
  withDate: false,
  step: 2,
};

export const CREATE_ASSUMPTIONS = {
  path: "assumptions/",
  subtitle: "Create assumptions",
  title: "",
  withStepper: true,
  withDate: false,
  step: 3,
};

export const CREATE_SCHEDULES = {
  path: "schedules/",
  subtitle: "Create Budget Scenario",
  title: "",
  withStepper: true,
  withDate: false,
  step: 4,
};

export const CREATE_TEMPLATES = {
  path: "templates/",
  subtitle: "Create Budget Scenario",
  title: "",
  withStepper: true,
  withDate: false,
  step: 5,
};

export const CREATE_WORKFORCE = {
  path: "workforce/",
  subtitle: "Workforce allocation",
  title: "",
  withStepper: true,
  withDate: false,
  step: 6,
};

export const OWNER_ASSIGNATION = {
  path: "owner/",
  subtitle: "Create Budget Scenario",
  title: "",
  withStepper: true,
  withDate: false,
  step: 7,
};

export const BUDGET_URL = `/${SECTION_BUDGET.path}`;

export const BUDGET_STEPS_ROUTES = {
  [START_BUDGET.step]: `${BUDGET_URL}${START_BUDGET.path}${START_BUDGET.params}`,
  [SELECT_ACCOUNTS.step]: `${BUDGET_URL}${SELECT_ACCOUNTS.path}`,
  [CREATE_COMPANY.step]: `${BUDGET_URL}${CREATE_COMPANY.path}`,
  [CREATE_ASSUMPTIONS.step]: `${BUDGET_URL}${CREATE_ASSUMPTIONS.path}`,
  [CREATE_SCHEDULES.step]: `${BUDGET_URL}${CREATE_SCHEDULES.path}`,
  [CREATE_TEMPLATES.step]: `${BUDGET_URL}${CREATE_TEMPLATES.path}`,
  [CREATE_WORKFORCE.step]: `${BUDGET_URL}${CREATE_WORKFORCE.path}`,
  [OWNER_ASSIGNATION.step]: `${BUDGET_URL}${OWNER_ASSIGNATION.path}`,
};
